const API_BASE = "https://api.touchprop.com/api/v1/myuser";

const DEFAULT_ERROR_MESSAGE = "خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.";

const ERROR_CODE_MAP = {
  EMAIL_TAKEN: "این ایمیل قبلا ثبت شده است.",
  USERNAME_TAKEN: "این نام کاربری قبلا گرفته شده است.",
  WEAK_PASSWORD: "رمز عبور ضعیف است.",
  EMAIL_SEND_FAILED: "ارسال ایمیل با خطا مواجه شد. لطفا دوباره تلاش کنید.",
  INVALID_REGISTRATION_DATA: "اطلاعات ثبت نام نامعتبر است.",
  EMAIL_NOT_VERIFIED: "ایمیل شما تایید نشده است. لطفا ابتدا ایمیل را تایید کنید.",
  INVALID_CREDENTIALS: "ایمیل یا رمز عبور نادرست است.",
  USER_NOT_FOUND: "کاربری با این ایمیل پیدا نشد.",
  INVALID_VERIFICATION_CODE: "کد تایید نامعتبر یا منقضی است.",
  INVALID_REQUEST: "درخواست نامعتبر است.",
  REFRESH_TOKEN_REQUIRED: "توکن رفرش لازم است.",
  INVALID_REFRESH_TOKEN: "توکن رفرش نامعتبر است.",
};

const ERROR_MESSAGE_MAP = {
  "Invalid credentials": "ایمیل یا رمز عبور نادرست است.",
  "Your email is not verified. Please verify your email first.":
    "ایمیل شما تایید نشده است. لطفا ابتدا ایمیل را تایید کنید.",
  "User not found": "کاربری با این ایمیل پیدا نشد.",
  "Invalid or expired verification code": "کد تایید نامعتبر یا منقضی است.",
  "Invalid registration data": "اطلاعات ثبت نام نامعتبر است.",
  "Invalid request data": "درخواست نامعتبر است.",
  "Failed to send email": "ارسال ایمیل با خطا مواجه شد. لطفا دوباره تلاش کنید.",
  "Email is already registered.": "این ایمیل قبلا ثبت شده است.",
  "Username is already taken.": "این نام کاربری قبلا گرفته شده است.",
  "Password must be at least 8 characters long.": "رمز عبور باید حداقل 8 کاراکتر باشد.",
  "Password must contain at least one uppercase letter.":
    "رمز عبور باید حداقل یک حرف بزرگ داشته باشد.",
  "Password must contain at least one lowercase letter.":
    "رمز عبور باید حداقل یک حرف کوچک داشته باشد.",
  "Password must contain at least one number.":
    "رمز عبور باید حداقل یک عدد داشته باشد.",
  "Enter a valid email address.": "ایمیل معتبر نیست.",
  "This field is required.": "تکمیل این فیلد الزامی است.",
  "This field may not be blank.": "این فیلد نباید خالی باشد.",
};

const findNestedValue = (payload, key, allowString = false) => {
  if (!payload) return null;
  if (allowString && typeof payload === "string") return payload;
  if (Array.isArray(payload)) {
    for (const item of payload) {
      const value = findNestedValue(item, key, allowString);
      if (value) return value;
    }
    return null;
  }
  if (typeof payload === "object") {
    if (typeof payload[key] === "string") return payload[key];
    for (const value of Object.values(payload)) {
      const nested = findNestedValue(value, key, allowString);
      if (nested) return nested;
    }
  }
  return null;
};

const getAuthErrorMessage = (data) => {
  const detailMessage =
    findNestedValue(data?.details, "error", true) || findNestedValue(data?.details, "detail", true);
  const detailCode = findNestedValue(data?.details, "error_code");
  const directMessage = data?.error || data?.detail;
  const directCode = data?.error_code;

  const candidates = [detailMessage, directMessage].filter(Boolean);
  for (const msg of candidates) {
    if (ERROR_MESSAGE_MAP[msg]) return ERROR_MESSAGE_MAP[msg];
  }

  const codes = [detailCode, directCode].filter(Boolean);
  for (const code of codes) {
    if (ERROR_CODE_MAP[code]) return ERROR_CODE_MAP[code];
  }

  return detailMessage || directMessage || DEFAULT_ERROR_MESSAGE;
};

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  let data;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const message = getAuthErrorMessage(data);
    const error = new Error(message);
    error.details = data;
    error.status = response.status;
    throw error;
  }

  return data;
}

export function registerUser(payload) {
  return request("/register/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function verifyCode(payload) {
  return request("/verify/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function loginUser(payload) {
  return request("/login/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function forgotPassword(payload) {
  return request("/forgot-password/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
